import type { HTMLAttributes } from 'react'

import styled from 'styled-components'
import { STATUS } from 'common'

type Props = {
  statusType:
    | 'ACTIVE'
    | 'INACTIVE'
    | 'RESERVED'
    | 'BLOCKED'
    | 'ACCEPTED'
    | 'FINALIZED'
    | 'DELETED'
    | 'CLOSED'
    | 'REMOVED'
} & HTMLAttributes<HTMLElement>

export default function Status({ statusType, ...props }: Props) {
  return (
    <Wrapper className={statusType} {...props}>
      {STATUS[statusType]}
    </Wrapper>
  )
}

const Wrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  ::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  &.ACTIVE {
    color: var(--green);
    ::before {
      color: var(--green);
      background-color: var(--green);
    }
  }

  &.INACTIVE {
    color: var(--gray);
    ::before {
      color: var(--gray);
      background-color: var(--gray);
    }
  }

  &.DELETED {
    color: var(--red);
    ::before {
      color: var(--red);
      background-color: var(--red);
    }
  }

  &.CLOSED {
    color: var(--yellow);
    ::before {
      color: var(--yellow);
      background-color: var(--yellow);
    }
  }

  &.RESERVED {
    color: var(--dark-blue);
    ::before {
      color: var(--blue);
      background-color: var(--dark-blue);
    }
  }

  &.ACCEPTED {
    color: var(--green_0-5);
    ::before {
      color: var(--green_0-5);
      background-color: var(--green_0-5);
    }
  }

  &.BLOCKED {
    color: var(--orange);
    ::before {
      color: var(--orange);
      background-color: var(--orange);
    }
  }

  &.FINALIZED {
    color: var(--dark-green);
    ::before {
      color: var(--dark-green);
      background-color: var(--dark-green);
    }
  }

  &.REMOVED {
    color: #616b66;
    ::before {
      color: #616b66;
      background-color: #616b66;
    }
  }
`
